import React from "react";
import StockList from "./InvestmentList";
import "./InvestmentList.css";

function InvestmentListPage() {
  return (
    <div>
      <StockList />
    </div>
  );
}

export default InvestmentListPage;
